import React from 'react';
import ConstituentIcon from './constituent_icon.svg';
import PhoneIcon from './phone.svg';
import MailIcon from './mail.svg';
import Tooltip from 'src/components/Tooltip';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { fetchAuthOrganizations } from 'src/redux/authOrganizations/authOrganization.action';
import { getAuthOrganizations } from 'src/redux/authOrganizations/authOrganization.selector';
import { DONORPERFECT_CRM } from 'src/utils/authOrg.constants';
import DonorLabels from 'src/components/DonorLabels';

import { FlexBox, Span, Box, HyperLink } from 'src/lib/StyledComponents';
import theme from 'src/lib/theme';

const CrmID = ({ constituent, raisersEdge }) => (
	<Box title="CRM ID" color={theme.colors.shadowBlue} whiteSpace="nowrap">
		<ConstituentIcon
			style={{ verticalAlign: 'middle', marginRight: '12px', marginTop: '-4px' }}
		/>
		{raisersEdge ? "Raiser's Edge ID " : 'Donor ID '}
		{constituent.crm_link ? (
			<HyperLink
				href={constituent.crm_link}
				color={theme.colors.cornflowerBlue}
				marginRight="20px"
				target="_blank"
			>
				{constituent.lookup_id || constituent.bb_id}
			</HyperLink>
		) : (
			<Span color={theme.colors.shadowBlue} marginRight="20px">
				{constituent.lookup_id || constituent.bb_id}
			</Span>
		)}
	</Box>
);

const ConstituentName = ({ constituent, showTooltip, linkName }) => (
	<Span
		fontWeight="bold"
		color={theme.colors.textColor}
		fontSize={theme.fontSizes[7]}
		marginRight="20px"
	>
		{linkName ? (
			<Link
				to={`/dashboard/donor/${constituent._id}`}
				style={{ color: theme.colors.textColor }}
			>
				{constituent.name}
			</Link>
		) : (
			constituent.name
		)}
		{showTooltip ? (
			<Tooltip
				urlDescription="quick video"
				urlPath="4177076-wisely-in-1-minute-the-donor-profile"
				name="Donor Profile"
				spanStyle={{ marginLeft: '5px' }}
			/>
		) : null}
	</Span>
);

const ConstituentEmail = ({ constituent }) =>
	constituent.email && constituent.email.address ? (
		<HyperLink
			href={constituent.email.address ? `mailto:${constituent.email.address}` : null}
			marginRight="20px"
			color={
				constituent.email.do_not_email
					? theme.colors.pastelRed
					: theme.colors.cornflowerBlue
			}
		>
			<MailIcon
				style={{
					verticalAlign: 'middle',
					marginLeft: '-5px',
					marginRight: '5px',
					marginTop: '-4px',
				}}
			/>
			{constituent.email.do_not_email ? 'Do not email' : constituent.email.address}
		</HyperLink>
	) : (
		<Span color={theme.colors.shadowBlue} marginRight="20px">
			<MailIcon
				style={{
					verticalAlign: 'middle',
					marginLeft: '-5px',
					marginRight: '5px',
					marginTop: '-4px',
				}}
			/>
			No Email
		</Span>
	);

const ConstituentPhone = ({ constituent }) =>
	constituent.phone && constituent.phone.number ? (
		<HyperLink
			href={constituent.phone.number ? `tel:${constituent.phone.number}` : null}
			color={
				constituent.phone.do_not_call ? theme.colors.pastelRed : theme.colors.cornflowerBlue
			}
			marginRight="20px"
		>
			<PhoneIcon style={{ verticalAlign: 'middle', marginRight: '5px', marginTop: '-4px' }} />
			{constituent.phone.do_not_call ? 'Do not call' : constituent.phone.number}
		</HyperLink>
	) : (
		<Span color={theme.colors.shadowBlue} marginRight="20px">
			<PhoneIcon style={{ verticalAlign: 'middle', marginRight: '5px', marginTop: '-4px' }} />
			No Phone
		</Span>
	);

const ConstituentPrimaryAddress = ({ constituent }) => {
	const buildAddress = () => {
		return `${constituent.address.state || ''} ${constituent.address.postal_code || ''} ${
			constituent.address.country || ''
		}`.trim();
	};
	return (
		<Box color={theme.colors.shadowBlue} whiteSpace="nowrap">
			{constituent.address ? (
				<React.Fragment>
					<ConstituentIcon
						style={{ verticalAlign: 'middle', marginRight: '12px', marginTop: '-4px' }}
					/>
					{buildAddress()}
				</React.Fragment>
			) : null}
		</Box>
	);
};

class ConstituentCard extends React.Component {
	componentDidMount(prevProps) {
		if (!this.props.authOrganizations.length > 0) {
			this.props.fetchAuthOrganizations();
		}
	}

	render() {
		const raisersEdgeCRMTypes = ['nxt', 'on-prem', 're7', 'demo'];
		const { constituent, authOrganizations, showLabel } = this.props;
		const crmType = authOrganizations.length > 0 ? authOrganizations[0].crm_type : null;
		if (!crmType) {
			return null;
		}

		return (
			<FlexBox id="identity_info" flexDirection="column">
				<FlexBox>
					<ConstituentName
						constituent={constituent}
						showTooltip={this.props.showTooltip}
						linkName={this.props.linkName}
					/>
					{showLabel && (
						<Box id="donor_labels">
							<DonorLabels donor={constituent} />
						</Box>
					)}
				</FlexBox>
				{constituent.portfolio_count >= 0 && (
					<Span color={theme.colors.shadowBlue}>
						Donors:{' '}
						<Span color={theme.colors.cornflower}>{constituent.portfolio_count}</Span>
					</Span>
				)}
				<FlexBox id="top_line_info" flexWrap="wrap" alignItems="center" marginTop="4px">
					<CrmID
						constituent={constituent}
						raisersEdge={raisersEdgeCRMTypes.includes(crmType)}
					/>
					<FlexBox id="contact_info" flexWrap="wrap" whiteSpace="nowrap">
						<ConstituentEmail constituent={constituent} />
						<ConstituentPhone constituent={constituent} />
					</FlexBox>
				</FlexBox>
				{crmType === DONORPERFECT_CRM && (
					<ConstituentPrimaryAddress constituent={constituent} />
				)}
			</FlexBox>
		);
	}
}

const mapStateToProps = state => ({
	authOrganizations: getAuthOrganizations(state),
});

const actions = {
	fetchAuthOrganizations,
};

ConstituentCard = connect(mapStateToProps, actions)(ConstituentCard);

export default ConstituentCard;



// WEBPACK FOOTER //
// ./src/ConnectedComponents/ConstituentCard/index.js